/**
 * debounce function call for given timeout
 * source: https://gist.github.com/ca0v/73a31f57b397606c9813472f7493a940
 */
export function debounce<F extends (...args: never[]) => void>(func: F, waitFor: number): (...args: Parameters<F>) => ReturnType<F> {
    let timeout: ReturnType<typeof setTimeout> | null = null;

    const debounced = (...args: Parameters<F>) => {
        if (timeout !== null) {
            clearTimeout(timeout);
            timeout = null;
        }
        timeout = setTimeout(() => func(...args), waitFor);
    };

    return debounced as (...args: Parameters<F>) => ReturnType<F>;
}

export function ensureExhaustive(value: never, errorMessage = `Reached a branch with non-exhaustive checks for value ${value}`): never {
    throw new Error(errorMessage);
}

export function warnIfNotExhaustive(value: never, errorMessage = `Reached a branch with non-exhaustive checks for value ${value}`): void {
    console.warn(errorMessage);
}

/**
 * A function that that does nothing.
 */
export function noop() {
    // noop
}
